import { createContext } from "react";

export function pathnameIsWelcomeTutorialPage(path: string): boolean {
  return path.startsWith("/welcome");
}

export enum WelcomeTutorialRoutes {
  LC_MANAGE_EMAILS = "/welcome/lc/manage-emails",
  LC_TICKET_FORM = "/welcome/lc/ticket-form",
  LC_MANAGEABLE_TICKETS = "/welcome/lc/manageable-tickets",
  LC_IMPORT_DATA = "/welcome/lc/import-data",
  WELCOME = "/welcome",
  FINISH = "/",
  FORWARDING = "/welcome/forwarding",
  MAILBOX = "/welcome/mailbox",
  INVITE = "/welcome/invite",
}

export enum WelcomeTutorialStep {
  Mailbox = "mailbox",
  Invite = "invite",
  Forwarding = "forwarding",
}

export const CompanyNameContext = createContext(false);
